import { isPositiveNumber, reduce } from "et3-type-guards";

import i18n from "../../../../constants/i18n";
import { SILENT_BANNED_FLAG } from "../../../../constants/input-entries-constants";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import BanButton from "../../../../core/et3-shared-components/action-buttons/BanButton";
import SilentBanButton from "../../../../core/et3-shared-components/action-buttons/SilentBanButton";
import { SURFACE_BORDER } from "../../../../core/et3-theme/surface-constants";
import { TUserEntry } from "../../../../Types";
import { countPendingItems } from "../../../../stores/approval-reject-store/approval-item-counts";
import ApprovalChip from "../ApprovalChip";
import ApprovalFact from "../ApprovalFact";
import ApprovalIdPill from "../ApprovalIdPill";
import {
  APPROVAL_GOLD_INK,
  APPROVAL_SOFT_DELETED,
  APPROVAL_SOFT_GOLD,
  APPROVAL_SOFT_REJECTED,
  APPROVAL_SOFT_TODO,
  APPROVAL_TODO_INK
} from "../approval-data-constants";
import {
  ROW_HEADER_ITEM_GAP,
  ROW_HEADER_PADDING_X,
  ROW_HEADER_PADDING_Y,
  ROW_HEADER_ROW_GAP,
  ROW_USERNAME_FONT_SIZE
} from "./lanes/lane-constants";

const UserRowHeader = withLiteObserverAndTheme<{ userEntry: TUserEntry }>(
  (props) => {
    const { userEntry, theme } = props;
    const { colors, unitX, unitY } = theme;
    const username = reduce(() => userEntry.username, "");
    const userId = reduce(() => userEntry.user_id, -1);
    const userUUID = reduce(() => userEntry.userUUID, "");
    const country = reduce(() => userEntry.country, "");
    const lastLogin = reduce(() => userEntry.last_login, "");
    const isVipUser = isPositiveNumber(reduce(() => userEntry.is_vip, 0));
    const isSilentBanned =
      reduce(() => userEntry.isSilentBanned, 0) === SILENT_BANNED_FLAG;
    const isUserReported = isPositiveNumber(
      reduce(() => userEntry.userUnderCSRReport, 0)
    );
    const isMaleUser = reduce(() => userEntry.gender, "m") === "m";
    const headerBackground = isMaleUser
      ? colors.all.bluishGreenish
      : colors.all.translucentPink;
    const pendingItems = countPendingItems(userEntry);
    const hasPendingWork = isPositiveNumber(pendingItems);
    const banExtraData = {
      userID: userId,
      userUUID: userUUID,
      reportedUUID: "",
      reportedID: -1,
      reportID: -1,
      secondPartyID: -1
    };

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={headerBackground}
        style={{
          boxSizing: "border-box",
          width: "100%",
          minWidth: 0,
          flexWrap: "wrap",
          borderBottom: SURFACE_BORDER,
          padding: `${ROW_HEADER_PADDING_Y * unitY}px ${
            ROW_HEADER_PADDING_X * unitX
          }px`,
          gap: `${ROW_HEADER_ROW_GAP * unitY}px ${
            ROW_HEADER_ITEM_GAP * unitX
          }px`
        }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={ROW_USERNAME_FONT_SIZE}
          text={username}
          isSpan={true}
          color={
            hasPendingWork ? colors.all.maastrichtBlue : colors.all.davysGrey
          }
          style={{ margin: 0 }}
        />
        <ApprovalIdPill userId={userId} />
        {isVipUser ? (
          <ApprovalChip
            label={i18n.get("VIP")}
            toneColor={APPROVAL_GOLD_INK}
            backgroundColor={APPROVAL_SOFT_GOLD}
          />
        ) : null}
        {isSilentBanned ? (
          <ApprovalChip
            label={i18n.get("SILENT_BANNED")}
            toneColor={colors.all.red}
            backgroundColor={APPROVAL_SOFT_REJECTED}
          />
        ) : null}
        <ApprovalChip
          label={
            hasPendingWork
              ? i18n.getWithExtraData(
                  "APPROVAL_TO_REVIEW_COUNT",
                  `${pendingItems}`
                )
              : i18n.get("APPROVAL_NOTHING_TO_REVIEW")
          }
          toneColor={hasPendingWork ? APPROVAL_TODO_INK : colors.all.gray}
          backgroundColor={
            hasPendingWork ? APPROVAL_SOFT_TODO : APPROVAL_SOFT_DELETED
          }
        />
        <ApprovalFact
          labelKey={"COUNTRY"}
          value={country}
          withLabel={false}
          isMachineValue={false}
        />
        <ApprovalFact
          labelKey={"LAST_LOGIN"}
          value={lastLogin}
          withLabel={true}
          isMachineValue={true}
        />
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={0}
          height={0}
          fDirection="row"
          alignItems="center"
          justifyContent="flex-end"
          color={colors.all.transparent}
          style={{
            flex: 1,
            width: "auto",
            minWidth: 0,
            height: "auto",
            minHeight: 0,
            gap: ROW_HEADER_ROW_GAP * unitX
          }}
          onClick={() => {}}
        >
          <BanButton
            extraData={banExtraData}
            fromPage="APPROVAL_DATA"
            disabled={isSilentBanned || isUserReported}
            size={"COMPACT"}
          />
          <SilentBanButton
            extraData={banExtraData}
            fromPage="APPROVAL_DATA"
            disabled={isSilentBanned || isUserReported}
            size={"COMPACT"}
          />
        </ET3Div>
      </ET3Div>
    );
  }
);
export default UserRowHeader;
